<script setup>

</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h1>Promotion bonus</h1>
              <p>The affiliate program will allow you to increase your income by receiving a percentage of the arbitrage pool opened by your referrals. Invite your friends to join the company.</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- affiliate -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12 col-lg-6">
            <!-- invest -->
            <div class="invest invest--big">
              <h2 class="invest__title">Volume bonus</h2>

              <p class="invest__text">The larger the arbitrage pool volume, the more bonus will be awarded upon reaching these goals!</p>

              <table class="invest__table">
                <thead>
                <tr>
                  <th>Bonus</th>
                  <th>Turnover</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>$100</td>
                  <td>$1 000 000</td>
                </tr>
                <tr>
                  <td>$250</td>
                  <td>$3 000 000</td>
                </tr>
                <tr>
                  <td>$400</td>
                  <td>$5 000 000</td>
                </tr>
                <tr>
                  <td>$650</td>
                  <td>$7 000 000</td>
                </tr>
                <tr>
                  <td class="blue">to $50 000</td>
                  <td>$10 000 000</td>
                </tr>
                </tbody>
              </table>

              <!-- design elements -->
              <span class="block-icon block-icon--blue">
							<i class="ti ti-mood-dollar"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end invest -->
          </div>

          <div class="col-12 col-lg-6">
            <!-- invest -->
            <div class="invest invest--big">
              <h2 class="invest__title">Leadership bonus</h2>

              <p class="invest__text">It is accrued on the first day of each month and depends on the turnover of arbitrage pools of the first level.</p>

              <table class="invest__table">
                <thead>
                <tr>
                  <th>Bonus</th>
                  <th>Pool</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>$500</td>
                  <td>$4 000</td>
                </tr>
                <tr>
                  <td>$1 250</td>
                  <td>$8 000</td>
                </tr>
                <tr>
                  <td>$2 500</td>
                  <td>$12 000</td>
                </tr>
                <tr>
                  <td>$7 000</td>
                  <td>$24 000</td>
                </tr>
                <tr>
                  <td class="yellow">$29 000</td>
                  <td>$99 000</td>
                </tr>
                </tbody>
              </table>

              <!-- design elements -->
              <span class="block-icon block-icon--yellow">
							<i class="ti ti-trophy"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end invest -->
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas"></div>
        </div>

        <div class="row">
          <div class="col-12">
            <!-- section btns -->
            <div class="section__btns">
              <a href="signin.html" class="section__btn">Become</a>
            </div>
            <!-- end section btns -->
          </div>
        </div>
      </div>
    </section>
    <!-- end affiliate -->

    <!-- question -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="question">
              <h2 class="question__title">Any questions?</h2>
              <p class="question__text">Our support team is always on call, and ready to help with all your questions!</p>

              <div class="section__btns section__btns--mt">
                <button class="section__btn section__btn--light" data-bs-target="#modal-ask" type="button" data-bs-toggle="modal">Ask a question</button>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							<i class="ti ti-info-circle"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--second" id="canvas2"></div>
        </div>
      </div>
    </section>
    <!-- end question -->
  </div>
</template>

<style scoped>

</style>
